export default (api) => {
    return {
        index: options => api.get('users', options),
        me: {
            get: options => api.get('me', options),
            update: (data, options) => api.put('me', data, options),
            schools: options => api.get('me/schools', options),
            school_challenges: options => api.get('me/schools/challenges', options),
            preferences: {
                get: options => api.get('preferences', options),
                update: (data, options) => api.put('preferences', data, options),
            }
        },
        get: (user_id, options) => api.get('users/' + user_id, options),
        update: (user_id, data, options) => api.put(`users/${user_id}`, data, options)
    }
}
